module.exports = __webpack_public_path__ + "static/img/fenxi1.febbfc24.png";